import ApplicationController from './application_controller'
import SlimSelect from 'slim-select'
import 'slim-select/styles'

export default class extends ApplicationController {
  static targets = ['select']

  connect () {
    this.selects = []
    this.selectTargets.forEach(selectElement => {
      const slimInstance = this.createSlimSelect(selectElement)
      const entry = { element: selectElement, instance: slimInstance, refreshHandler: null }

      // Listen for refresh events to rebuild SlimSelect when options change
      entry.refreshHandler = () => {
        entry.instance.destroy()
        entry.instance = this.createSlimSelect(selectElement)
      }

      selectElement.addEventListener('slim-select:refresh', entry.refreshHandler)
      this.selects.push(entry)
    })
  }

  disconnect () {
    this.selects.forEach(({ element, instance, refreshHandler }) => {
      element.removeEventListener('slim-select:refresh', refreshHandler)
      instance.destroy()
    })
    this.selects = []
  }

  createSlimSelect (selectElement) {
    const settings = {
      placeholderText: selectElement.dataset.placeholder,
      searchPlaceholder: selectElement.dataset.searchPlaceholder || 'Search'
    }
    const events = {}

    if (selectElement.dataset.searchMode === 'word_start') {
      settings.showSearch = true
      settings.searchText = 'No matching option'
      events.searchFilter = (option, search) => this.wordStartsWithSearch(option, search)
    }

    // What the list shows when nothing matches the search, when the page names it
    if (selectElement.dataset.searchText) {
      settings.searchText = selectElement.dataset.searchText
    }

    return new SlimSelect({
      select: selectElement,
      settings: settings,
      events: events
    })
  }

  normalizeForSearch (text) {
    return text
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  }

  wordsFromOptionText (text) {
    return this.normalizeForSearch(text)
      .split(/[^\p{L}\p{N}]+/u)
      .filter(word => word.length > 0)
  }

  wordStartsWithSearch (option, search) {
    const searchTokens = this.normalizeForSearch(search)
      .trim()
      .split(/\s+/)
      .filter(token => token.length > 0)

    if (searchTokens.length === 0) return true

    const words = this.wordsFromOptionText(option.text)

    return searchTokens.every(token =>
      words.some(word => word.startsWith(token))
    )
  }
}
